<script setup>
  import { Button } from "@/components/ui/button";
</script>

<template>
  <div
    class="flex min-h-[calc(100vh-120px)] w-full flex-col items-center justify-center"
    data-cy="forbidden-page">
    <p class="heading-display">
      You're not supposed to be here
    </p>
    <p class="mt-3 text-sm text-muted-foreground">This page is restricted. Let's get you back on track.</p>
    <Button
      class="mt-8"
      as="a"
      href="/">
      Back to dashboard
    </Button>
  </div>
</template>
